export default function hasElementOrSomeParentTheClass(target: EventTarget | null, classname: string): boolean {
  if (!target || !(target instanceof Node)) {
    return false
  }

  let current: Node | null = target instanceof Element ? target : target.parentElement

  while (current) {
    if (current instanceof Element && current.classList.contains(classname)) {
      return true
    }
    current = current.parentElement
  }

  return false
}

/** For document-level mousedown handlers: walk composedPath so SVG/shadow hits still match (e.g. mic dropdown gear). */
export function eventComposedPathHasClass(event: MouseEvent, className: string): boolean {
  if (typeof event.composedPath === 'function') {
    for (const node of event.composedPath()) {
      if (node instanceof Element && node.classList.contains(className)) {
        return true
      }
    }
  }

  return hasElementOrSomeParentTheClass(event.target, className)
}
